module.exports='<div ui-view="" ng-if="managerLayoutCtrl.isLogged"></div>';